import { Component, Vue, Prop } from 'vue-property-decorator'
import FileTable from './FileTable'
import { Modal } from 'ant-design-vue'
import { downloadGET } from '@/api/api'
import ViewDetail from './ViewDetail/index.vue'

const DIVIDER = '$&&---bj---&&$'
@Component({
  FileTable,
  ViewDetail
})
export default class ComparePanel extends Vue {
  public compareVersion: any = { displayName: '' }
  public compareVersionIndex: number = 0
  public compareVersionFiles: any = []
  isClicked = false
  @Prop() data: any
  @Prop() current: any
  @Prop() currentIndex: number

  public detailvisible = false
  public detail = {}
  titleNode(text) {
    return (
      <div style="border-left: 4px solid #3a7fbc; color: #3a7fbc; padding-left: 8px; margin-bottom: 16px;">{text}</div>
    )
  }

  selectCompareVersion(item: any, index: number) {
    console.log(item)
    this.compareVersion.displayName = item.displayName
    this.compareVersionIndex = index
    this.compareVersionFiles = this.data[index].files
  }

  async handleDiff(rightFile) {
    if (this.isClicked) {
      return
    }
    this.isClicked = true
    const leftFile = this.data[this.currentIndex].files.find(item => item.displayName === rightFile.displayName)
    let res: any
    try {
      res = await Promise.all([
        downloadGET(leftFile.displayName, leftFile.objectKey, leftFile.contentType),
        downloadGET(rightFile.displayName, rightFile.objectKey, rightFile.contentType),
      ])
      const fr = new FileReader()
      const blob = new Blob([res[0], DIVIDER, res[1]])

      fr.readAsText(blob)
      // fr.readAsText(new Blob([res[1]]))
      fr.onload = () => {
        const res = (fr.result as string).split(DIVIDER)
        Modal.info({
          title: `${rightFile.displayName}：\n`,
          icon: () => null,
          content: (
            <div style="display: flex; justify-content: space-around">
              <textarea readonly cols="30" rows="10" style="margin-right: 16px">
                {res[0]}
              </textarea>
              <textarea readonly cols="30" rows="10">
                {res[1]}
              </textarea>
            </div>
          ),
          maskClosable: false,
          onOk: () => {
            console.log('close')
            this.isClicked = false
          },
          onCancel: () => {
            console.log('close')
            this.isClicked = false
          },
        })
      }
    } catch (e) {
      this.$message.error('文件不存在')
      this.isClicked = false
    }
  }

  openPreview(record){
    this.detail = record
    this.detailvisible = true
  }
  closeDetail(){
    this.detailvisible = false
  }
  render() {
    return (
      <div class="compare-panel">
        <div class="header">
          <div class="left">
            {this.$t('page_resource_pool_currentv')}（{this.current.displayName}）
          </div>
          <a-divider type="vertical" style="height: 100%" />
          <div class="right">
            {this.$t('page_resource_pool_comparev')}（{this.compareVersion.displayName}）
            <a-dropdown>
              <a>
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay">
                {this.data.map((item, index) => {
                  return (
                    <a-menu-item>
                      <a onClick={() => this.selectCompareVersion(item, index)}>{item.displayName}</a>
                    </a-menu-item>
                  )
                })}
              </a-menu>
            </a-dropdown>
          </div>
        </div>
        <div class="body">
          <div class="left">
            {this.titleNode(this.$t('page_resource_pool_job_gram'))}
            <FileTable readOnly={true} data={this.data[this.currentIndex].files.filter(item => item.fileType === 1)} onPreview={this.openPreview} />
            {this.titleNode(this.$t('page_resource_pool_art'))}
            <FileTable readOnly={true} data={this.data[this.currentIndex].files.filter(item => item.fileType === 2)} onPreview={this.openPreview} />
          </div>
          <a-divider type="vertical" style="height: 100%; margin: 0" />
          <div class="right">
            {this.titleNode(this.$t('page_resource_pool_job_gram'))}
            <FileTable
              readOnly={true}
              data={this.compareVersionFiles.filter(item => item.fileType === 1)}
              isCompare={true}
              onDiff={this.handleDiff}
              onPreview={this.openPreview}
            />
            {this.titleNode(this.$t('page_resource_pool_art'))}
            <FileTable
              readOnly={true}
              data={this.compareVersionFiles.filter(item => item.fileType === 2)}
              isCompare={true}
              onDiff={this.handleDiff}
              onPreview={this.openPreview} 
            />
          </div>
        </div>
        <ViewDetail visible={this.detailvisible} item={this.detail} onClose={this.closeDetail}/>
      </div>
    )
  }
}
